import { render } from "./PartMileage.vue?vue&type=template&id=2cbe46bc"
import script from "./PartMileage.vue?vue&type=script&lang=js"
export * from "./PartMileage.vue?vue&type=script&lang=js"
script.render = render

export default script